import { UserType } from 'types/user'

export const FETCH_USERS = 'FETCH_USERS'
export const fetchUsersAction = (users: UserType[]) => {
  return {
    type: 'FETCH_USERS',
    payload: users,
  }
}

export const INIT_USERS = 'INIT_USERS'
export const initUsersAction = () => {
  return {
    type: 'INIT_USERS',
    payload: null,
  }
}
